import api from "./axios";

export type ParsingManageHotelUrls = Partial<{
  ostrovok: string;
  t_travel: string;
  official_website: string;
  yandex_travel: string;
  sutochno: string;
  alean: string;
  booking: string;
  ozon: string;
}>;

export type ParsingManageHotelItem = {
  title: string;
  main_uid: string | null;
  local_id?: number | null;
  urls: ParsingManageHotelUrls;
  changed?: Array<keyof ParsingManageHotelUrls>;
  is_base: boolean;
};

export type ParsingManageDepth = 30 | 90 | 120 | 180;
export type ParsingManageInterval = 1 | 4 | 30 | 60 | 90 | 120;
export type ParsingManageGuests = 1 | 2 | 4;

export type ParsingManageSetting = {
  min_stay: number;
  depth: ParsingManageDepth;
  interval: ParsingManageInterval;
  guests: ParsingManageGuests;
};

export type ParsingManageHotelsPayload = {
  group_id: number;
  hotels: ParsingManageHotelItem[];
  parsing_settings?: ParsingManageSetting[];
};

export type ParsingManageHotelsResponse = {
  status: "ok" | "error";
  errors: unknown[] | null;
};

export type ParsingSwitchAction = "enable" | "disable";

export type ParsingSwitchResponse = {
  status: "ok" | "error";
  error: unknown | null;
};

export type ParsingSettingsPayload = {
  group_id: number;
  min_stay: number;
  depth: number;
  interval: number;
  guests: number;
  start_now: 0 | 1;
};

export type ParsingSettingsDeletePayload = {
  group_id: number;
  task_id: number;
};

export type ParsingSettingsResponse = {
  status: "ok" | "error";
  error: unknown | null;
};

export type ParsingStatusTask = {
  task_id?: number | null;
  group_id?: number | string | null;
  min_stay?: number | string | null;
  depth?: number | string | null;
  interval?: number | string | null;
  guests?: number | string | null;
  guests_child?: number | string | number[] | string[] | null;
  children?: number | string | number[] | string[] | null;
  create_date?: string | null;
  last_date?: string | null;
};

export type ParsingStatusHotelItem = {
  group_id?: number | string | null;
  parsing?: ParsingStatusTask[] | null;
  tasks?: ParsingStatusTask[] | null;
  parsings?: ParsingStatusTask[] | null;
  items?: ParsingStatusTask[] | null;
  min_stay?: number | string | null;
  guests?: number | string | null;
  guests_child?: number | string | number[] | string[] | null;
};

export type ParsingStatusResponse =
  | ParsingStatusHotelItem[]
  | ParsingStatusTask[]
  | Record<string, ParsingStatusHotelItem | ParsingStatusTask[] | ParsingStatusTask | null>
  | {
      status?: "ok" | "error";
      error?: unknown | null;
      data?: ParsingStatusHotelItem[] | ParsingStatusTask[] | Record<string, ParsingStatusHotelItem | ParsingStatusTask[] | ParsingStatusTask | null>;
      items?: ParsingStatusHotelItem[] | ParsingStatusTask[] | Record<string, ParsingStatusHotelItem | ParsingStatusTask[] | ParsingStatusTask | null>;
      result?: ParsingStatusHotelItem[] | ParsingStatusTask[] | Record<string, ParsingStatusHotelItem | ParsingStatusTask[] | ParsingStatusTask | null>;
      parsings?: ParsingStatusHotelItem[] | ParsingStatusTask[] | Record<string, ParsingStatusHotelItem | ParsingStatusTask[] | ParsingStatusTask | null>;
      objects?: ParsingStatusHotelItem[] | ParsingStatusTask[] | Record<string, ParsingStatusHotelItem | ParsingStatusTask[] | ParsingStatusTask | null>;
    };

export async function manageHotels(payload: ParsingManageHotelsPayload) {
  const { data } = await api.post<ParsingManageHotelsResponse>("/api/v1/parsing/manage_hotels", payload);
  return data;
}

export async function switchParsing(groupId: number, action: ParsingSwitchAction) {
  const { data } = await api.post<ParsingSwitchResponse>("/api/v1/parsing/parsing_switch", {
    group_ids: [groupId],
    action,
  });
  return data;
}

export async function saveParsingSettings(payload: ParsingSettingsPayload) {
  const { data } = await api.post<ParsingSettingsResponse>("/api/v1/parsing/parsing_settings", payload);
  return data;
}

export async function deleteParsingSettings(payload: ParsingSettingsDeletePayload) {
  const { data } = await api.post<ParsingSettingsResponse>("/api/v1/parsing/parsing_settings_delete/", payload);
  return data;
}

export async function getParsingStatus() {
  const { data } = await api.get<ParsingStatusResponse>("/api/v1/parsing/parsing_status");
  return data;
}
